import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { apiUrl } from "../../config/config";
import { getFromLocalStorage } from "../../utils/helperFunctions";

const getPreviewImage = (item) => {
  if (!Array.isArray(item?.imagePreviews)) {
    return "https://via.placeholder.com/150";
  }

  return (
    item.imagePreviews.find((preview) => preview.part === "Front")?.preview ||
    item.imagePreviews[0]?.preview ||
    "https://via.placeholder.com/150"
  );
};

const HeaderCartPreview = ({ cartLength = 0, children }) => {
  const [open, setOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    setHasFetched(false);
  }, [cartLength]);

  const fetchCartPreview = useCallback(() => {
    const email = Cookies.get("Email_guest") || getFromLocalStorage("Email");

    if (!email || loading || hasFetched) {
      return;
    }

    setLoading(true);

    const headers = new Headers();
    headers.append("Authorization", `Bearer ${localStorage.getItem("APP_TOKEN")}`);

    fetch(`${apiUrl}/api/checkouts/email/${email}`, {
      method: "GET",
      headers,
      redirect: "follow",
    })
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setCartItems(data);
        } else if (data && typeof data === "object") {
          setCartItems([data]);
        } else {
          setCartItems([]);
        }
        setHasFetched(true);
      })
      .catch((error) => {
        console.error("Error fetching cart preview:", error);
        setCartItems([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [hasFetched, loading]);

  const handleMouseEnter = () => {
    setOpen(true);
    fetchCartPreview();
  };

  const subtotal = cartItems.reduce(
    (total, item) => total + (parseFloat(item?.totalPrice) || 0),
    0
  );

  return (
    <div
      className="header-cart-preview"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setOpen(false)}
    >
      <Link to="/cart" aria-label="Cart" className="header-cart-preview-trigger">
        {children}
        {cartLength > 0 && <span className="header-two-cart-count">{cartLength}</span>}
      </Link>

      {open && (
        <div className="header-cart-preview-dropdown">
          {loading ? (
            <div className="header-cart-preview-loading">
              <span />
              <span />
              <span />
            </div>
          ) : cartItems.length > 0 ? (
            <>
              <div className="header-cart-preview-list">
                {cartItems.slice(0, 3).map((item) => (
                  <div className="header-cart-preview-item" key={item.id}>
                    <img src={getPreviewImage(item)} alt={item.productName || "Cart item"} />
                    <div className="header-cart-preview-info">
                      <h4>{item.designName || "Untitled Design"}</h4>
                      <p>{item.productName || "Product"}</p>
                      <span>
                        Qty {item.totalQuantity || 0}
                        {item.unitPrice ? ` @ $${item.unitPrice} each` : ""}
                      </span>
                      <strong>${parseFloat(item.totalPrice || 0).toFixed(2)}</strong>
                    </div>
                  </div>
                ))}
              </div>

              <div className="header-cart-preview-footer">
                <div>
                  <span>Total Styles</span>
                  <strong>{cartItems.length}</strong>
                </div>
                <div>
                  <span>Order Subtotal</span>
                  <strong>${subtotal.toFixed(2)}</strong>
                </div>
              </div>

              <Link to="/cart" className="header-cart-preview-button">
                Review Cart & Check Out
              </Link>
            </>
          ) : (
            <div className="header-cart-preview-empty">
              <strong>Your cart is empty</strong>
              <span>Add a design to see it here.</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default HeaderCartPreview;
